import { GetContrastColorBW } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, Card, Col } from "antd";
import { observer } from "mobx-react-lite";
import React, { CSSProperties } from "react";
import { TourId } from "../../types/TourId";

export const PseudoRouteCard = observer(() => {
  const routeColor = "#4CAF50";
  const routeTextColor = GetContrastColorBW(routeColor);

  const getStyle = (): CSSProperties => {
    return {
      borderLeftColor: routeColor,
      borderLeftWidth: 5,
      borderRadius: 5,
    };
  };

  return (
    <Col
      xs={24}
      sm={24}
      md={12}
      lg={8}
      xl={6}
      id={TourId.Route.card}
      style={{ display: "none" }}
    >
      <Card
        title={<div id={TourId.Route.cardHeader}>ZB1 Pseudo Route</div>}
        style={getStyle()}
        styles={{
          header: {
            backgroundColor: routeColor,
            color: routeTextColor,
          },
        }}
        actions={[
          <Button
            type="text"
            icon={<Icon icon="fa:route" />}
            id={TourId.Route.cardActionTrip}
          />,
          <Button
            icon={<Icon color="red" icon="fa:trash" />}
            shape="circle"
            type="text"
            id={TourId.Route.cardActionDelete}
          />,
          <Button
            icon={<Icon icon="fa:pen" />}
            shape="circle"
            type="text"
            id={TourId.Route.cardActionEdit}
          />,
        ]}
      >
        <div id={TourId.Route.cardBody}>
          <p>Typ: Bus</p>
          <p>
            Webseite:
            <a>Link zu Ihrer Webseite</a>
          </p>
          <p>Beschreibung dieser Route</p>
        </div>
      </Card>
    </Col>
  );
});
